import { loadCdnScripts } from "@ecom/ui/utils/api"
import "./src/styles/index.scss"

export const onClientEntry = () => {
  loadCdnScripts()
}